export default class SubscriberProfileService {
	constructor(apiService) {
		this.apiService = apiService
	}

	deleteEntity(id, params) {
		return this.apiService.callDelete('subscriberProfile/' + id, params)
	}

	getEntity(id, params) {
		return this.apiService.callGet('subscriberProfile/' + id, params)
	}

	createEntity(params) {
		return this.apiService.callPost('subscriberProfile', params)
	}

	updateEntity(id, params) {
		return this.apiService.callPut('subscriberProfile/' + id, params)
	}

	getImageList(params){
		return this.apiService.callGet('subscriberProfile/imageList', params);
	}

	getMaturityRatingList(){
		return this.apiService.callGet('subscriberProfile/maturityRatingList');
	}

	getSelectboxList(idSubscriber, params){
		return this.apiService.callGet('subscriberProfile/subscriberProfiles/'+idSubscriber, params)
	}
}



// WEBPACK FOOTER //
// ./src/service/SubscriberProfileService.js